export default "__VITE_ASSET__7f604992__$_#icon-run-man__"